// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"dc0cd81f","831":"116ed66b"}[chunkId] + ".chunk.css";
};